
<template>
    <div class="table-body">
        <!-- 操作按钮 -->
        <div class="opt-btn">
            <el-button size="small" type="primary" v-if="hasBtnPermission('btn_supervise_reply')" icon="el-icon-plus" @click="batchReplyHandler">批量回复</el-button>
        </div>

        
        <!-- <el-form :model="replyForm" ref="replyForm" label-width="150px" style="position: relative">
            <el-row>
                <el-col :span="24" v-for="(item,index) in replyForm.attachments" :key="index" >
                    <el-form-item :label="item.fileTypeName?(item.fileTypeName+'：'):'附件：'" :prop="'attachments' + item.fileType"  size="small">
                        <affix-msg
                                :type="'check_result_att'"
                                :docItem.sync="item"
                                :docName.sync="item.name"
                                @uploadSuccess="uploadSuccess"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form> -->


        <!-- 表格数据 -->
        <el-table  :data="replyList" class="table-content"  row-key="id" v-loading="dataListLoading" :header-cell-style="this.$globalGrayTableHeaderStyle" ref="multipleTable" stripe border @selection-change="handleSelectionChange"
            @filter-change="filterChange"
            @sort-change="sortChange">
            <el-table-column fixed type="index" align="center" label="序号" width="60" :index="getRowsIndex"></el-table-column>
            <el-table-column fixed type="selection" align="center" :reserve-selection="true" :selectable="selected"></el-table-column>

            <el-table-column column-key="receiveStatusCondition" label="接收状态" prop='receiveStatus' align="center" width="90px" :show-overflow-tooltip='true'
            :filters="[{ text: '待接收', value: 0 },{ text: '已接收', value: 1 },{ text: '已失效', value: 2 }]">
                <template slot-scope="scope">
                    <i :class="formatterStatusClass(scope.row.receiveStatus)"></i>
                    <span>{{formatterStatusName(scope.row.receiveStatus)}}</span>
                </template>
            </el-table-column>

            <el-table-column label="回复状态" prop='takeReplyStatus' align="center" width='100' :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.takeReplyStatus == '部分回复'">{{scope.row.takeReplyStatus}}</el-tag>
                    <el-tag type="success" v-else-if="scope.row.takeReplyStatus == 1">已回复</el-tag>
                    <el-tag type="danger" v-else>未回复</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="督办标题" prop='title' header-align="center" align="left" min-width='200' :show-overflow-tooltip='true'>
                <template slot="header" slot-scope="scope">
                    <div class="custom-header">
                        <span>督办标题</span>
                        <el-popover width="300" trigger="click">
                            <div class="custom-section">
                                <p>请输入</p>
                                <el-input v-model="queryData.filter.title" clearable></el-input>
                                <div class="custom-section--btns">
                                    <el-button size="mini" type="text" @click="cancelFilter">取消</el-button>
                                    <el-button size="mini" type="primary" @click="filterHandler">确定</el-button>
                                </div>
                            </div>
                            <i slot="reference" class="el-icon-search"></i>
                        </el-popover>
                    </div>
                </template>
                <template slot-scope="scope">
                    <div class="row-overflow">{{scope.row.title}}</div>
                </template>
            </el-table-column>
            <el-table-column label="督办部门" prop='deptName'  align="left" width='150' :show-overflow-tooltip='true'>
                <template slot="header" slot-scope="scope">
                    <div class="custom-header">
                        <span>督办部门</span>
                        <el-popover width="300" trigger="click">
                            <div class="custom-section">
                                <p>请输入</p>
                                <el-input v-model="queryData.filter.deptName" clearable></el-input>
                                <div class="custom-section--btns">
                                    <el-button size="mini" type="text" @click="cancelFilter">取消</el-button>
                                    <el-button size="mini" type="primary" @click="filterHandler">确定</el-button>
                                </div>
                            </div>
                            <i slot="reference" class="el-icon-search"></i>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="督办时间" prop='inspectorTime' align="center" width='170' :show-overflow-tooltip='true' :sortable="true">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.createTime,'yyyy-MM-dd HH:mm:ss')}}</span>
                </template>
            </el-table-column>

            <el-table-column label="回复时限" prop='timeLimit' align="center" width='150' :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                    <p v-if="scope.row.isTimeOut && scope.row.replyStatus == -1" style="margin: 0;">{{scope.row.limitDays}} <span style="color: red;">（已超时）</span></p>
                    <p v-else style="margin: 0;">{{scope.row.limitDays}}</p>
                </template>
            </el-table-column>

            <el-table-column label="督办对象" prop='inspectorObjects' align="left" width='250' :show-overflow-tooltip='true'>
                <template slot="header" slot-scope="scope">
                    <div class="custom-header">
                        <span>督办对象</span>
                        <el-popover width="300" trigger="click">
                            <div class="custom-section">
                                <p>请输入</p>
                                <el-input v-model="queryData.filter.inspectorObjects" clearable></el-input>
                                <div class="custom-section--btns">
                                    <el-button size="mini" type="text" @click="cancelFilter">取消</el-button>
                                    <el-button size="mini" type="primary" @click="filterHandler">确定</el-button>
                                </div>
                            </div>
                            <i slot="reference" class="el-icon-search"></i>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            
            <el-table-column label="回复时间" prop='replyTime' align="center" width='170' :show-overflow-tooltip='true' :sortable="true">
                <template slot-scope="scope">
                    <span>{{scope.row.replyTime}}</span>
                </template>
            </el-table-column>

            <el-table-column label="回复内容" prop='replyContent' align="left" width='160' :show-overflow-tooltip='true'>
                <template slot="header">
                    <div class="custom-header"><span>回复内容</span></div>
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small"  @click="viewDetail(scope.row)">查看</el-button>
                    <el-button type="text" size="small" title="修改" @click="replyHandler(scope.row)" v-show="scope.row.receiveStatus != 2">回复</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination background
            layout="total, sizes, prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            :current-page="pageIndex"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle">
        </el-pagination>

        <!-- 弹窗区域 -->


        <el-dialog
          title="督办回复"
          :visible.sync="replyDialogVisible"
          width="50%">

            <el-form ref="form" :model="replyForm" :rules="replyRules" label-width="100px">
                <el-form-item label="回复内容：" prop="replyContent">
                    <el-input type="textarea" v-model="replyForm.replyContent" placeholder="请输入回复内容" :maxlength="255"></el-input>
                </el-form-item>
                <el-form-item label="回复人员：" prop="replyUser">
                    <el-input v-model="replyForm.replyUser"></el-input>
                </el-form-item>
                <el-form-item label="回复单位：" prop="replyDeptName">
                    <el-input v-model="replyForm.replyDeptName" disabled></el-input>
                </el-form-item>
                <el-form-item label="回复时间：" prop="replyUser">
                    <el-input value="提交后自动生成" disabled></el-input>
                </el-form-item>
                <el-form-item label="相关附件：">
                    <el-upload
                      class="upload-demo"
                      action
                      :show-file-list="false"
                      :http-request="upload"
                      :file-list="fileList"

                      >
                      <div style="display: flex; flex-direction: column;">
                        <el-button size="small" type="primary" style="width: 120px">点击上传</el-button>
                        <ul>
                          <li v-for="(item, index) in fileList" :key="index">{{item.name}}</li>
                        </ul>
                      </div>
                    </el-upload>

                    <!-- <el-upload
                      class="upload-demo"
                      action
                      :show-file-list="false"
                      :http-request="upload"
                      :before-upload="beforeAvatarUpload"

                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="3"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      >
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload> -->

                </el-form-item>

                
            </el-form>

            <span slot="footer" class="dialog-footer">
              <el-button @click="cancelReply">取 消</el-button>
              <el-button type="primary" @click="replyConfirm">确 定</el-button>
            </span>
        </el-dialog>




    </div>

</template>

<script>
import affixMsg from "@/components/affixMsg";
import { mapState } from "vuex";

export default {
    props: {
        keyword: {
            type: String,
            default: ''
        },
        tradeId:{
            type: String,
            default: ''
        }
    },
    components: {
      affixMsg,
    },

    data() {
        return {
            historyid:"",
            multipleSelection:[],
            pageSize: 10,//每页条数
            pageIndex: 1,//当前页

            // 加载状态
            dataListLoading: false,
            filterPopoverVisible: false,

            tableMaxHeight: document.documentElement.clientHeight - 347,


            // 查询参数对象
            queryData: {
                page: 1,
                rows: 10,
                orderBy: '',
                searchKey: '',
                filter: {
                    searchType: 1,
                    deptName: '',
                    inspectorObjects: '',
                    title: '',
                    receiveStatus: '',
                },
            },
          
            // 列表数据
            replyList: [],
            fileList: [],
            total: 0,

            // 弹窗数据
            replyDialogVisible: false,
            replyForm: {
                inspectorId: '',
                inspectorIds: [],
                replyContent: '',
                replyUser: '',
                replyDeptName: '',
                replyDeptCode: '',
                attachments: []
            },

            replyRules: {
                replyContent: [
                  { required: true, message: '请输入回复内容', trigger: 'blur' },
                ],
                replyUser: [
                  { required: true, message: '请输入回复人员名称', trigger: 'blur' },
                ],
                replyDeptName: [
                  { required: true, message: '回复单位不能为空', trigger: 'blur' },
                ],
            }
        };
    },
    watch: {
        keyword (newVal) {
            this.resetData();
            this.queryData.searchKey = newVal;
            this.getReplyList();
        },
        uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){
            this.getReplyList();
          }
        }
    }
    },
    computed: {
    ...mapState({
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
    })
  },
    created() {
        if (this.keyword) {
            this.queryData.searchKey = this.keyword;
        }
        this.getReplyList();


        this.replyForm.attachments=[{
                "appId": "8e607712e0a345689212b3eb49ac92a0",
                "attributes": {},
                "categoryCode": "complaint_matter_att",
                "categoryId": "115a9a34f0ae49e78402cb8b7c0b5e86",
                "createTime": "2021-12-10 14:44:24",
                "createUser": "系统管理员",
                "delFlag": false,
                "fileType": "1",
                "name": "",
                "remark": "{\"required\":false,\"allows\":\".jpg,.jpeg,.png,.gif,.bmp,.pdf\"}",
                "sort": 1,
                "updateTime": "2022-02-23 13:50:49",
                "updateUser": "系统管理员",
                "value": "1",
                "required": false,
                "allows": ".jpg,.jpeg,.png,.gif,.bmp,.pdf",
                "templateSrc": "",
                "describeInfo": "",
                "fileTypeName": "相关附件",
                "filePath": ""
            }]





    },
    methods: {
        handleSelectionChange(val){
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },

        uploadSuccess(fileType){
            this.$refs['replyForm'].clearValidate(['attachments'+fileType]);
        },

        formatterStatusClass(historyId){
            switch(historyId){
                case 0: return 'icon-point icon-point-verificationing'; break;
                case 1: return 'icon-point icon-point-success'; break;
                case 2: return 'icon-point icon-point-info'; break;
                default:return ''; break;
            }
        },

        upload(file) {
            //上传
            var formData = new FormData();
            formData.append("xlsFile", file.file);
            this.$httpReq.post("/attachment/uploadFile", formData).then(({data}) => {
                console.log(data)
                if (data.code == "1") {
                    let file = {
                        allows: ".jpg,.jpeg,.png,.gif,.bmp,.pdf",
                        appId: "8e607712e0a345689212b3eb49ac92a0",
                        attributes: {},
                        categoryCode: "complaint_matter_att",
                        categoryId: "115a9a34f0ae49e78402cb8b7c0b5e86",
                        createTime: "2021-12-10 14:44:24",
                        createUser: "系统管理员",
                        delFlag: false,
                        describeInfo: "",
                        fileType: "1",
                        fileTypeName: "相关附件",
                        remark: "{\"required\":false,\"allows\":\".jpg,.jpeg,.png,.gif,.bmp,.pdf\"}",
                        required: false,
                        sort: 1,
                        templateSrc: "",
                        updateTime: "2022-02-23 13:50:49",
                        updateUser: "系统管理员",
                        value: "1",

                        name: data.data.name,
                        filePath: data.data.filepath,
                        url: data.data.filepath,
                        extendName: data.data.extendName,

                    }
                    this.replyForm.attachments.push(file);
                    this.fileList.push(file);
                    console.log(this.replyForm.attachments)

                } else {
                  this.$message({ message: "上传失败", type: "error" });
                }
            }).catch(e => {});
        },


        // beforeAvatarUpload(file) {
        //   const isJPG =
        //     file.type === "image/jpeg" ||
        //     file.type === "image/png" ||
        //     file.type === "image/jpg";
        //   const isLt2M = file.size / 1024 / 1024 < 2;

        //   if (!isJPG) {
        //     this.$message.error("上传图标只能是 jpg|jpeg|png 格式!");
        //   }
        //   if (!isLt2M) {
        //     this.$message.error("上传图标大小不能超过 2MB!");
        //   }
        //   return isJPG && isLt2M;
        // },



        formatterStatusName(historyId){
            switch(historyId){
                case 0: return '待接收'; break;
                case 1: return '已接收'; break;
                case 2: return '已失效'; break;
                default:return ''; break;
            }
        },
        getRowsIndex(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        sizeChangeHandle(val) {
            this.queryData.rows = val;
            this.getReplyList();
        },
        currentChangeHandle (val) {
            this.queryData.page = val;
            this.getReplyList();
        },

        routerAdd(){
            removeTabHandle('synthesize_superviseAndHandle_sendForm')
            this.$router.push({
                name:'synthesize_superviseAndHandle_sendForm',
                query:{
                    id:'',
                }
            })

        },

        viewDetail(row){ // 跳转详情
            removeTabHandle('synthesize_superviseAndHandle_sendView')
            this.$router.push({
                name:'synthesize_superviseAndHandle_sendView',
                query:{
                  id: row.id,
                  active: 'received'
                }
            })

        },

		/* *********************** 逻辑处理 *********************** */

        // 重置查询数据
        resetData () {
            this.queryData = {
                page: 1,
                rows: 10,
                orderBy: '',
                searchKey: '',
                filter: {
                    searchType: 1,
                },
            };
        },



        // 重置回复表单
        resetReplyForm () {
            this.replyForm = {
                inspectorId: '',
                inspectorIds: [],
                replyContent: '',
                replyUser: '',
                replyDeptName: '',
                attachments: []
            };
            this.replyForm.replyDeptName = this.$store.state.user.userinfo.orgInfo.deptName||this.$store.state.user.userinfo.orgInfo.orgName || '超级管理员';
            this.replyForm.replyDeptCode = this.$store.state.user.userinfo.orgInfo.deptCode||this.$store.state.user.userinfo.orgInfo.legalCode || '';
            this.replyForm.replyUser = this.$store.state.user.displayName || '';
            this.replyForm.attachments = [];
            this.fileList = [];
        },

        // 督办回复处理
        replyHandler (row) {
            // if (row.receiveStatus==0) {
            //     this.updateReceiveStatus(row.id);
            // }

            this.resetReplyForm();
            this.replyForm.inspectorId = row.id;
            this.replyDialogVisible = true;
        },

        // 批量督办回复处理
        batchReplyHandler () {
            this.resetReplyForm();
            let ids = this.multipleSelection.map(item => {
                return item.id;
            })
            console.log(ids)
            this.replyForm.inspectorIds = ids;
            if (this.replyForm.inspectorIds.length>0) {
                this.replyDialogVisible = true;
            } else {
                this.$message.warning('请至少选择一条督办数据');
            }
        },

        // 督办回复确认
        replyConfirm () {
            console.log(this.replyForm);
            if (this.replyForm.replyContent) {
                this.saveReply();
            } else {
                this.$message.warning('请输入回复内容');
            }
        },

        // 取消回复
        cancelReply () {
            this.replyForm = {
                inspectorId: '',
                inspectorIds: [],
                replyContent: '',
                replyUser: '',
                replyDeptName: '',
                attachments: []
            };
            this.replyDialogVisible = false;
        },

        selected(row, index) {
        	if (row.receiveStatus == 2) {
        		return false //不可勾选
        	} else {
        		return true; //可勾选
        	}
        },

        // 筛选
        filterChange (val) {
            console.log(val)
            if (val.receiveStatusCondition && val.receiveStatusCondition.length>0) {
                this.queryData.filter.receiveStatusCondition = val.receiveStatusCondition.join(',');
            } else {
                this.queryData.filter.receiveStatusCondition = '';
            }
            // if (val.replyStatus && val.replyStatus.length>0) {
            //     this.queryData.filter.replyStatus = val.replyStatus.join(',');
            // }
            this.getReplyList();
        },
        filterHandler () {
            console.log(this.queryData);
            this.getReplyList();
            document.querySelector(".table-body").click();
        },

        cancelFilter () {
            document.querySelector(".table-body").click();
        },

        // 排序
        sortChange (val) {
            console.log(val);
            switch (val.order) {
                case 'descending': this.queryData.orderBy = val.prop + ' desc'; break;
                case 'ascending': this.queryData.orderBy = val.prop + ' asc'; break;
                default: this.queryData.orderBy = '';
            }
            this.getReplyList();
        },



		/* *********************** 接口调用 *********************** */
      
        // 获取列表数据
        getReplyList (parentObj) {
            this.queryData.searchKey=parentObj?parentObj.searchKey:this.keyword
            this.queryData.filter.superviseDeptCodeList=parentObj?parentObj.superviseDeptCodeList:this.uerdefultOptionCode
            this.dataListLoading=true;
            this.$httpReq.post('/application/inspector/list', {
                ...this.queryData
            }).then(({data}) => {
                this.replyList = data.rows;
                this.total = data.total;
                this.dataListLoading = false;
                if (this.keyword) {
                    this.$emit('findDataNumber', this.total)
                }

            })
        },

        // 督办回复
        saveReply () {
            this.dataListLoading=true;
            this.$httpReq.post('/application/inspectorReply/save', {
                ...this.replyForm
            }).then(({data}) => {
                console.log(data);
                this.dataListLoading= false;

                if (data.code == '1') {
                    this.$message({
                        type: 'success',
                        message: '回复成功!'
                    });
                    this.replyDialogVisible = false;
                    this.getReplyList();
                } else {
                    this.$message({
                        type: 'error',
                        message: data.msg
                    });
                }
            })
        },



    },
};
</script>
<style lang="scss" scoped>
    .table-body{
        // margin:16px 24px;
        background: #ffffff;
        // padding: 15px 24px;
        margin-bottom: 0;
        .opt-btn{
            // margin-bottom:16px;
            padding: 16px;
        }
    }

    /deep/ .messageIndex {
        z-index: 9999 !important; // 设置的值一定要比2007大，因为dialog的层级是2007
    }
.custom-header {
    display: flex;
    justify-content: start;
    line-height: 25px;
    margin-top: 5px;
    padding-left: 0;
    i {
        margin-left: 10px;
        cursor: pointer;
        &:hover {
            opacity: .8;
        }
    }
}
.custom-section {
    padding: 20px;
    .custom-section--btns {
        text-align: right;
        margin-top: 20px;
    }
}
.row-overflow {
    overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}

</style>
